// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: stop_keywords.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "stop_keywords";

/** References */
export interface StopKeywordReferences {
  globalFunctions: { [key: string]: boolean };
}

export interface StopKeywordReferences_GlobalFunctionsEntry {
  key: string;
  value: boolean;
}

/** Wrapper for regular expressions to enable optional updates */
export interface RegularExpressions {
  patterns: string[];
}

export interface StopKeywords {
  filters: StopKeyword[];
}

/** Base message for a stop keyword */
export interface StopKeyword {
  id: string;
  title: string;
  description: string;
  regularExpressions: string[];
  sayPhrase: boolean;
  references: StopKeywordReferences | undefined;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
  languageCode: string;
}

/** Command to create stop keywords */
export interface StopKeywordCreate {
  id: string;
  title: string;
  description: string;
  regularExpressions: string[];
  sayPhrase: boolean;
  references: StopKeywordReferences | undefined;
  languageCode: string;
}

/** Command to update existing stop keywords */
export interface StopKeywordUpdate {
  id: string;
  title?: string | undefined;
  description?: string | undefined;
  regularExpressions: string[];
  sayPhrase?: boolean | undefined;
  references?: StopKeywordReferences | undefined;
  languageCode?: string | undefined;
}

/** Command to delete stop keywords */
export interface StopKeywordDelete {
  id: string;
}

function createBaseStopKeywordReferences(): StopKeywordReferences {
  return { globalFunctions: {} };
}

export const StopKeywordReferences: MessageFns<StopKeywordReferences> = {
  encode(message: StopKeywordReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.globalFunctions).forEach(([key, value]: [string, boolean]) => {
      StopKeywordReferences_GlobalFunctionsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeywordReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeywordReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StopKeywordReferences_GlobalFunctionsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.globalFunctions[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeywordReferences {
    return {
      globalFunctions: isObject(object.globalFunctions)
        ? (globalThis.Object.entries(object.globalFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StopKeywordReferences): unknown {
    const obj: any = {};
    if (message.globalFunctions) {
      const entries = globalThis.Object.entries(message.globalFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.globalFunctions = {};
        entries.forEach(([k, v]) => {
          obj.globalFunctions[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeywordReferences>): StopKeywordReferences {
    return StopKeywordReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopKeywordReferences>): StopKeywordReferences {
    const message = createBaseStopKeywordReferences();
    message.globalFunctions = (globalThis.Object.entries(object.globalFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStopKeywordReferences_GlobalFunctionsEntry(): StopKeywordReferences_GlobalFunctionsEntry {
  return { key: "", value: false };
}

export const StopKeywordReferences_GlobalFunctionsEntry: MessageFns<StopKeywordReferences_GlobalFunctionsEntry> = {
  encode(message: StopKeywordReferences_GlobalFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeywordReferences_GlobalFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeywordReferences_GlobalFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeywordReferences_GlobalFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StopKeywordReferences_GlobalFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeywordReferences_GlobalFunctionsEntry>): StopKeywordReferences_GlobalFunctionsEntry {
    return StopKeywordReferences_GlobalFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<StopKeywordReferences_GlobalFunctionsEntry>,
  ): StopKeywordReferences_GlobalFunctionsEntry {
    const message = createBaseStopKeywordReferences_GlobalFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRegularExpressions(): RegularExpressions {
  return { patterns: [] };
}

export const RegularExpressions: MessageFns<RegularExpressions> = {
  encode(message: RegularExpressions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.patterns) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegularExpressions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegularExpressions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.patterns.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegularExpressions {
    return {
      patterns: globalThis.Array.isArray(object?.patterns) ? object.patterns.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: RegularExpressions): unknown {
    const obj: any = {};
    if (message.patterns?.length) {
      obj.patterns = message.patterns;
    }
    return obj;
  },

  create(base?: DeepPartial<RegularExpressions>): RegularExpressions {
    return RegularExpressions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RegularExpressions>): RegularExpressions {
    const message = createBaseRegularExpressions();
    message.patterns = object.patterns?.map((e) => e) || [];
    return message;
  },
};

function createBaseStopKeywords(): StopKeywords {
  return { filters: [] };
}

export const StopKeywords: MessageFns<StopKeywords> = {
  encode(message: StopKeywords, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.filters) {
      StopKeyword.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeywords {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeywords();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters.push(StopKeyword.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeywords {
    return {
      filters: globalThis.Array.isArray(object?.filters) ? object.filters.map((e: any) => StopKeyword.fromJSON(e)) : [],
    };
  },

  toJSON(message: StopKeywords): unknown {
    const obj: any = {};
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => StopKeyword.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeywords>): StopKeywords {
    return StopKeywords.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopKeywords>): StopKeywords {
    const message = createBaseStopKeywords();
    message.filters = object.filters?.map((e) => StopKeyword.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStopKeyword(): StopKeyword {
  return {
    id: "",
    title: "",
    description: "",
    regularExpressions: [],
    sayPhrase: false,
    references: undefined,
    createdBy: "",
    createdAt: undefined,
    updatedBy: "",
    updatedAt: undefined,
    languageCode: "",
  };
}

export const StopKeyword: MessageFns<StopKeyword> = {
  encode(message: StopKeyword, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.regularExpressions) {
      writer.uint32(34).string(v!);
    }
    if (message.sayPhrase !== false) {
      writer.uint32(40).bool(message.sayPhrase);
    }
    if (message.references !== undefined) {
      StopKeywordReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(58).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(66).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(74).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(82).fork()).join();
    }
    if (message.languageCode !== "") {
      writer.uint32(90).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeyword {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeyword();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.regularExpressions.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sayPhrase = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = StopKeywordReferences.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeyword {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      regularExpressions: globalThis.Array.isArray(object?.regularExpressions)
        ? object.regularExpressions.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.regular_expressions)
        ? object.regular_expressions.map((e: any) => globalThis.String(e))
        : [],
      sayPhrase: isSet(object.sayPhrase)
        ? globalThis.Boolean(object.sayPhrase)
        : isSet(object.say_phrase)
        ? globalThis.Boolean(object.say_phrase)
        : false,
      references: isSet(object.references) ? StopKeywordReferences.fromJSON(object.references) : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
    };
  },

  toJSON(message: StopKeyword): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.regularExpressions?.length) {
      obj.regularExpressions = message.regularExpressions;
    }
    if (message.sayPhrase !== false) {
      obj.sayPhrase = message.sayPhrase;
    }
    if (message.references !== undefined) {
      obj.references = StopKeywordReferences.toJSON(message.references);
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeyword>): StopKeyword {
    return StopKeyword.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopKeyword>): StopKeyword {
    const message = createBaseStopKeyword();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.regularExpressions = object.regularExpressions?.map((e) => e) || [];
    message.sayPhrase = object.sayPhrase ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? StopKeywordReferences.fromPartial(object.references)
      : undefined;
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseStopKeywordCreate(): StopKeywordCreate {
  return {
    id: "",
    title: "",
    description: "",
    regularExpressions: [],
    sayPhrase: false,
    references: undefined,
    languageCode: "",
  };
}

export const StopKeywordCreate: MessageFns<StopKeywordCreate> = {
  encode(message: StopKeywordCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.regularExpressions) {
      writer.uint32(34).string(v!);
    }
    if (message.sayPhrase !== false) {
      writer.uint32(40).bool(message.sayPhrase);
    }
    if (message.references !== undefined) {
      StopKeywordReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    if (message.languageCode !== "") {
      writer.uint32(58).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeywordCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeywordCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.regularExpressions.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sayPhrase = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = StopKeywordReferences.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeywordCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      regularExpressions: globalThis.Array.isArray(object?.regularExpressions)
        ? object.regularExpressions.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.regular_expressions)
        ? object.regular_expressions.map((e: any) => globalThis.String(e))
        : [],
      sayPhrase: isSet(object.sayPhrase)
        ? globalThis.Boolean(object.sayPhrase)
        : isSet(object.say_phrase)
        ? globalThis.Boolean(object.say_phrase)
        : false,
      references: isSet(object.references) ? StopKeywordReferences.fromJSON(object.references) : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
    };
  },

  toJSON(message: StopKeywordCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.regularExpressions?.length) {
      obj.regularExpressions = message.regularExpressions;
    }
    if (message.sayPhrase !== false) {
      obj.sayPhrase = message.sayPhrase;
    }
    if (message.references !== undefined) {
      obj.references = StopKeywordReferences.toJSON(message.references);
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeywordCreate>): StopKeywordCreate {
    return StopKeywordCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopKeywordCreate>): StopKeywordCreate {
    const message = createBaseStopKeywordCreate();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.regularExpressions = object.regularExpressions?.map((e) => e) || [];
    message.sayPhrase = object.sayPhrase ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? StopKeywordReferences.fromPartial(object.references)
      : undefined;
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseStopKeywordUpdate(): StopKeywordUpdate {
  return {
    id: "",
    title: undefined,
    description: undefined,
    regularExpressions: [],
    sayPhrase: undefined,
    references: undefined,
    languageCode: undefined,
  };
}

export const StopKeywordUpdate: MessageFns<StopKeywordUpdate> = {
  encode(message: StopKeywordUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== undefined) {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.regularExpressions) {
      writer.uint32(34).string(v!);
    }
    if (message.sayPhrase !== undefined) {
      writer.uint32(40).bool(message.sayPhrase);
    }
    if (message.references !== undefined) {
      StopKeywordReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    if (message.languageCode !== undefined) {
      writer.uint32(58).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeywordUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeywordUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.regularExpressions.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sayPhrase = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = StopKeywordReferences.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeywordUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      regularExpressions: globalThis.Array.isArray(object?.regularExpressions)
        ? object.regularExpressions.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.regular_expressions)
        ? object.regular_expressions.map((e: any) => globalThis.String(e))
        : [],
      sayPhrase: isSet(object.sayPhrase)
        ? globalThis.Boolean(object.sayPhrase)
        : isSet(object.say_phrase)
        ? globalThis.Boolean(object.say_phrase)
        : undefined,
      references: isSet(object.references) ? StopKeywordReferences.fromJSON(object.references) : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : undefined,
    };
  },

  toJSON(message: StopKeywordUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.regularExpressions?.length) {
      obj.regularExpressions = message.regularExpressions;
    }
    if (message.sayPhrase !== undefined) {
      obj.sayPhrase = message.sayPhrase;
    }
    if (message.references !== undefined) {
      obj.references = StopKeywordReferences.toJSON(message.references);
    }
    if (message.languageCode !== undefined) {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeywordUpdate>): StopKeywordUpdate {
    return StopKeywordUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopKeywordUpdate>): StopKeywordUpdate {
    const message = createBaseStopKeywordUpdate();
    message.id = object.id ?? "";
    message.title = object.title ?? undefined;
    message.description = object.description ?? undefined;
    message.regularExpressions = object.regularExpressions?.map((e) => e) || [];
    message.sayPhrase = object.sayPhrase ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StopKeywordReferences.fromPartial(object.references)
      : undefined;
    message.languageCode = object.languageCode ?? undefined;
    return message;
  },
};

function createBaseStopKeywordDelete(): StopKeywordDelete {
  return { id: "" };
}

export const StopKeywordDelete: MessageFns<StopKeywordDelete> = {
  encode(message: StopKeywordDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopKeywordDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopKeywordDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopKeywordDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: StopKeywordDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<StopKeywordDelete>): StopKeywordDelete {
    return StopKeywordDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopKeywordDelete>): StopKeywordDelete {
    const message = createBaseStopKeywordDelete();
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
